"use strict";
function isFunction(x) {
    return typeof x === 'function';
}
exports.isFunction = isFunction;
//# sourceMappingURL=isFunction.js.map


//////////////////
// WEBPACK FOOTER
// /Users/apple/Documents/object/chinaicac-portal/node_modules/_rxjs@5.5.12@rxjs/util/isFunction.js
// module id = ../../../../_rxjs@5.5.12@rxjs/util/isFunction.js
// module chunks = vendor